import { cloneDeep, merge } from 'lodash'

const messageResultTemplate = Object.freeze({
  event: '{% event_name %}',
  time: '{% event.action.create_time %}',
  properties: {
    message_type: '{% message_type %}',
    campaign_id: '{% event.action.campaign_id | int %}',
    trigger_id: '{% event.action.trigger_id | int %}',
    profile_id: '{% recipient.profile_id %}',
    device_id: '{% recipient.device_id | int | default(null) %}',
    external_message_id: '{% recipient.external_message_id | default(null) %}',
    error_message: '{% error_message %}',
    user_id: '{% user_id %}',
    email: '{% email %}',
    customer_id: '{% customer_id %}'
  }
})

const messageReportTemplate = Object.freeze({
  event: '{% event_name %}',
  time: '{% event.time %}',
  properties: {
    message_type: '{% message_type %}',
    campaign_id: '{% event.campaignID | int %}',
    trigger_id: '{% event.triggerID | int %}',
    message_id: '{% event.messageID %}',
    profile_id: '{% event.targetedProfileID %}',
    device_id: '{% event.targetedClientID | int | default(null) %}',
    external_message_id: '{% event.externalMessageID %}',
    user_id: '{% event.targetedProfileUserID %}',
    email: '{% event.targetedProfileEmail %}',
    customer_id: '{% event.targetedProfileCustomerID | default(null) %}'
  }
})

const messageReportTemplateWithError = Object.freeze(
  merge(cloneDeep(messageReportTemplate), {
    properties: {
      error_message: '{% error_message %}'
    }
  })
)

const messageFailureTemplate = Object.freeze({
  event: '{% event_name %}',
  time: '{% event.action.create_time %}',
  properties: {
    message_type: '{% message_type %}',
    campaign_id: '{% event.action.campaign_id | int %}',
    trigger_id: '{% event.action.trigger_id | int %}',
    profile_id: '{% recipient.profile_id %}',
    device_id: '{% recipient.device_id | int | default(null) %}',
    external_message_id: '{% recipient.external_message_id | default(null) %}',
    error_message: '{% error_message %}',
    user_id: '{% user_id %}',
    email: '{% email %}',
    customer_id: '{% customer_id %}'
  }
})

const messageSubscriptionTemplate = Object.freeze({
  event: '{% event_name %}',
  time: '{% event.time %}',
  properties: {
    channel: '{% channel %}',
    status: '{% status %}',
    profile_id: '{% profile_id %}',
    email: '{% email %}',
    user_id: '{% user_id %}',
    customer_id: '{% customer_id %}'
  }
})

const preferenceSubscriptionTemplate = Object.freeze({
  event: '{% event_name %}',
  time: '{% event.time %}',
  properties: {
    channel: '{% channel %}',
    preference: '{% preference %}',
    status: '{% status %}',
    profile_id: '{% profile_id %}',
    device_id: '{% device_id %}',
    email: '{% email %}',
    user_id: '{% user_id %}',
    customer_id: '{% customer_id %}'
  }
})

const payloadTemplates = Object.freeze({
  message_send: cloneDeep(messageResultTemplate),
  message_failure: cloneDeep(messageFailureTemplate),
  message_bounce: cloneDeep(messageReportTemplateWithError),
  message_open: cloneDeep(messageReportTemplate),
  message_click: cloneDeep(messageReportTemplate),
  message_delivery: cloneDeep(messageReportTemplate),
  message_unsubscribe: cloneDeep(messageReportTemplate),
  message_complaint: cloneDeep(messageReportTemplate),
  message_subscription_change: cloneDeep(messageSubscriptionTemplate),
  preference_subscription_change: cloneDeep(preferenceSubscriptionTemplate)
})

export { payloadTemplates }



// WEBPACK FOOTER //
// ./src/modules/integrations/enum/webhook/PayloadTemplates.js